import dayjs from 'dayjs';

export const formatDate = (
  date: number | null | undefined,
  format: string
): string | null => {
  return date ? dayjs(date * 1000).format(format) : null;
};

export const today = () => dayjs().toDate().getTime();

export const dayOfWeek = [
  'lunedì',
  'martedì',
  'mercoledì',
  'giovedì',
  'venerdì',
  'sabato',
  'domenica',
];

export const fromHoursToMilliseconds = (
  date: number | null | undefined
): number | null => {
  return date ? date * 60 * 60 * 1000 : null;
};

/**
 * Funzione per verificare se la data da controllare risulta essere di una persona che ha almeno 18 anni
 * @param controlDate - data da controllare
 * @param splitChar - carattere che indica il divisore dei parametri giorno mese e anno della data da verificare
 * @returns - boolean
 */
export const calculateAdultAge = (
  controlDate: string,
  splitChar: string
): boolean => {
  const today = new Date();
  const eighteenYearAgoTimestamp = today.setFullYear(today.getFullYear() - 18);

  const [year, month, day] = controlDate.split(splitChar);
  const insertDateTimestamp = new Date(
    Number(year),
    Number(month) - 1,
    Number(day)
  ).getTime();

  return insertDateTimestamp < eighteenYearAgoTimestamp;
};

/**
 * Funzione per estrapolare la data di nascita dal codice fiscale - funzione presa da vecchio progetto
 * @param cf - codice fiscale da cui tirare fuori la data di nascita
 * @returns - data di nascita in formato aaaa/mm/gg
 */
export const getDataByCf = (cf: string): string => {
  const codiceFiscale = cf.toUpperCase();
  const tabellaMesi: { [key: string]: string } = {
    A: '01',
    B: '02',
    C: '03',
    D: '04',
    E: '05',
    H: '06',
    L: '07',
    M: '08',
    P: '09',
    R: '10',
    S: '11',
    T: '12',
  };

  const anno = Number(codiceFiscale.substring(6, 8));
  let giorno = Number(codiceFiscale.substring(9, 11));

  const sesso = giorno > 31 ? 'F' : 'M';
  if (sesso === 'F') giorno -= 40;

  let year = new Date().getFullYear();
  year = Number(year.toString().substring(2, 4));
  const formatData =
    (anno < year ? '20' : '19') +
    anno +
    '/' +
    tabellaMesi[codiceFiscale.charAt(8)] +
    '/' +
    giorno;
  return formatData;
};

/**
 * Funzione per trasformare data in formato DD/MM/YYYY
 * @param date - data da trasformare - deve essere in formato YYYY-MM-DD
 */
export const formatData = (date: string): string => {
  if (!date) return '';

  const [year, month, day] = date.split('-');
  return day + '/' + month + '/' + year;
};

/**
 * Funzione per trasformare data in formato DD/MM/YYYY
 * @param date - data da trasformare - deve essere in formato YYYY-MM-DD
 */
export const formatDataSlash = (date: string): string => {
  const [year, month, day] = date.split('/');
  return day + '/' + month + '/' + year;
};

/**
 * Funzione per trasformare data in formato yyyy-mm-dd
 * @param date - data da trasformare - deve essere in formato DD/MM/YYYY
 */
export const formatDataToAmerican = (date: string): string => {
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}`;
};

export const formatDataYYYYMMDDTime = (data: string): string => {
  const [day, month, year] = data.split('/');
  const newDate = year + '-' + month + '-' + day;
  return dayjs(newDate).format('YYYY-MM-DDTHH:mm:ssZ[Z]');
};

export const formatTimeHHmmToDayjsDate = (time: string): dayjs.Dayjs => {
  const [hour, minute] = time.split(':');
  const dayjsDate = dayjs().hour(Number(hour)).minute(Number(minute));
  return dayjsDate;
};

export const formatDateYYYYMMDDToDayjsDate = (time: string) => {
  return dayjs(time, 'YYYYMMDD').format('YYYY-MM-DD');
};

export const formatDateTime = (time: number) => {
  return dayjs(time).format('DD/MM/YYYY HH:mm');
};
